/**
 * CommonMark 파서의 CJK bold 렌더링 문제를 해결하기 위한 전처리
 *
 * CommonMark 스펙의 right-flanking delimiter run 규칙에 따라,
 * 닫는 `**` 뒤에 한국어 조사 등 CJK 문자가 공백 없이 바로 붙으면
 * emphasis 닫기 구분자로 인식하지 못합니다.
 *
 * 해결: 닫는 `**` 뒤에 zero-width space(​)를 삽입하여
 * CommonMark 파서가 정상적으로 bold를 파싱하도록 유도합니다.
 */
export function preprocessMarkdown(text: string | null | undefined): string {
  if (!text) return '';

  return text.replace(/(\*\*(?:(?!\*\*).)+?\*\*)(?=[^\s*\p{P}])/gu, '$1​');
}
